import { React, Link } from 'react';


const getText = () => {
    return {


        "ERROR_WHILE_CONNECTING_TO_SERVER": () => {
            return "Errore di rete";
        },

        "CONFIRM_DELETE_MODAL_TITLE": () => {
            return `Sei sicuro di voler cancellare l'elemento?`;
        },

        "CONFIRM_DELETE_MODAL_BODY": (params) => {
            const { item } = params;
            const _name = Array.isArray(item) ? `i ${item.length} elementi` : item.item.Name
            return `Sei sicuro di voler cancellare ${_name}?`;

        },

        "CLOSE": () => {
            return `Chiudi`;

        },

        "DELETE": () => {
            return `Elimina`;

        },
        "DELETE_LONG_MESSAGE":()=>{
            return `Elimina l'elemento!`
        },
        "CLOSE_LONG_MESSAGE":()=>{
            return `Annulla l'azione!`
        },
        "FILE_NOT_FOUND":()=>{
            return `File non trovato`
        },
        "ERROR":()=>{
            return `Errore`
        },
        "YES": () => {
            return `Si`
        },
        "NO": () => {
            return `No`
        }
    }



}

export { getText };